import React, {useState, useEffect, useContext, useRef} from "react";
import {store} from '../../context/store';
import {functions} from "../../constants/common-functions";
import {colorFunctions} from "../../constants/colors";
import {useHistory} from 'react-router-dom';
import backgroundImage from "../../../images/nationwidebackground.png";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {DEFAULT_BLUE} from "../../constants/general-constants";
import {GREY_BACKGROUND} from "../../constants/general-constants";
import {PURPLE} from "../../constants/general-constants";
import UtilisationKpi from "../utilisation/components/UtilisationKpi";
import UtilisationChartLineSmall from "../utilisation/components/UtilisationChartLineSmall";
import UtilisationChartBarSmall from "../utilisation/components/UtilisationChartBarSmall";
import UtilisationChartBarBreakdown from "../utilisation/components/UtilisationChartBarBreakdown";
import UtilisationOutliers from "../utilisation/components/UtilisationOutliers";
import AmChartDoughnutIndicator from "../../components/AmChartDoughnutIndicator";
import UtilisationDiary from "../utilisation/components/UtilisationDiary";
import ForgeViewer from "../../components/ForgeViewer";
import UtilisationChartBarProfile from "../utilisation/components/UtilisationChartBarProfile";

export default function UtilisationRoom(){
	
	const globalState = useContext(store);
	const {dispatch} = globalState;
	const history = useHistory();
	
	const URN = "dXJuOmFkc2sud2lwZW1lYTpmcy5maWxlOnZmLlpmSGhXd0tHU0stS3g3QTVZWHFhcVE_dmVyc2lvbj0x";

	useEffect(() => {
		
	}, []);
  
  const thisContainer = {
  	display:"flex",
  	position:"fixed",
  	flexDirection:"column",
  	width:"100%",
  	height:"100vh",
  	left:"0px",
  	top:"0px",
  	//backgroundColor:GREY_BACKGROUND
  };
  
  const mainContainer = {
  	display:"flex",
  	position:"fixed",
  	top:"60px",
  	left:"60px",
  	bottom:"0px",
  	right:"0px",
  	flexDirection:"column",
  	overflow:"auto"
  };
  
  const topContainer = {
  	display:"flex",
  	width:"100%",
  	height:"calc(100% - 200px)"
  };
  
  const bottomContainer = {
  	display:"flex",
  	width:"100%",
  	height:"200px"
  };
  
  const planContainer = {
  	display:"flex",
  	width:"calc(100% - 400px)",
  	height:"100%",
  	backgroundColor:"#eee"
  };
  
  const rightContainer = {
  	display:"flex",
  	flexDirection:"column",
  	height:"100%",
  	width:"400px"
  };
  
  const titleContainer = {
  	display:"flex",
  	height:"40px",
  	alignItems:"center",
  	justifyContent:"space-around",
  	fontSize:"14px",
  	width:"100%",
  	fontWeight:"bold"
  };
  
  const indicatorContainer = {
  	display:"flex",
  	width:"33%",
  	flexDirection:"column",
  	marginTop:"-20px"
  };
  
  const indicatorTitle = {
  	display:"flex",
  	alignItems:"center",
  	justifyContent:"space-around",
  	fontSize:"12px",
  	width:"100%",
  	fontWeight:"bold",
  	marginTop:"-30px"
  };
  
  const indicatorRow = {
  	display:"flex",
  	width:"calc(100% - 20px)",
  	justifyContent:"space-between",
  	marginLeft:"10px"
  };
  
  const neverUsed = {
  	display:'flex',
  	width:"100px",
  	height:"100px",
  	backgroundColor:"darkred",
  	borderRadius:"10px",
  	flexDirection:"column",
  	marginTop:"5px",
  	marginRight:"10px"
  };
  
  const neverUsedTitle = {
  	display:"flex",
  	height:"30px",
  	fontSize:"14px",
  	color:"white",
  	width:"100%",
  	justifyContent:"space-around",
  	alignItems:"center"
  };
  
   const neverUsedFigure = {
  	display:"flex",
  	fontSize:"36px",
  	color:"white",
  	width:"100%",
  	justifyContent:"space-around",
  	alignItems:"center"
  };
  
  const loadForge = (model) => {
  	//console.log("In load module");
  	//console.log(model.getData());
  	
  };
	
	return (
			<div style={thisContainer}>
				<Header/>
				<LeftMenu/>	
				<div style={mainContainer}>
					<div style={topContainer}>
						<div style={planContainer}>
							<ForgeViewer
								urn={URN}
								viewerLeft="0px"
								viewerRight="400px"
								viewerZIndex="1000"
								viewerTop="0px"
								viewerBottom="200px"
								loadFunction={loadForge}
							/>
						</div>
						<div style={rightContainer}>
							<div style={titleContainer}>
								Floor 3: Room 1
							</div>
							<div style={indicatorRow}>
								<div style={indicatorContainer}>
									<AmChartDoughnutIndicator
										id="utilisationindicatorroomutilisation"
										percentage="76"
										width="100"
										height="100"
									/>
									<div style={indicatorTitle}>
										Average Utilisation
									</div>
								</div>
								<div style={indicatorContainer}>
									<AmChartDoughnutIndicator
										id="utilisationindicatorroomcapacity"
										percentage="46"
										width="100"
										height="100"
									/>
									<div style={indicatorTitle}>
										Average % Capacity
									</div>
								</div>
								<div style={neverUsed}>
									<div style={neverUsedTitle}>
										Never Used
									</div>
									<div style={neverUsedFigure}>
										23
									</div>
								</div>
							</div>
							<UtilisationDiary/>
							<UtilisationChartBarProfile/>
						</div>
					</div>
					<div style={bottomContainer}>
						<UtilisationChartBarSmall/>
						<UtilisationChartLineSmall/>
					</div>
				</div>
			</div>
	);
}